import GoogleAnalytics from '../components/common/GoogleAnalytics';
import App from 'next/app'
import '../styles/utils/globals.scss';
import { getCommonContentfulData } from '../libs/repositories/contentful';

function MyApp({ Component, pageProps, commonData }) {
    return (
        <>
            <GoogleAnalytics />
            <Component {...pageProps} commonData={commonData} />
        </>
    );
}

MyApp.getInitialProps = async (appContext) => {
    // 既存のPage levelのgetInitialPropsを呼び出し
    const appProps = await App.getInitialProps(appContext);
    
    // 共通データを取得（全ページで使用）
    const commonData = await getCommonContentfulData();
    
    return {
        ...appProps,
        commonData,
    };
};

export default MyApp;
